<template>
  <section class="query">
    <div class="query-header">
      <com-tabs
        @change="changeTab"
        :list="statisticsInfo.obj.tabs5"
        class="query-tabs"
        :defaultTab="activeTab"
      >
        <template v-slot:text="{ obj }">
          <div
            :class="{ activeTab: activeTab == obj.key }"
            class="query-tabs-item"
          >
            {{ obj.name }}
          </div>
        </template>
      </com-tabs>
      <div v-show="activeTab == 1">
        <span class="btn2" @click="addDialog = true">新建</span>
        <span class="btn1" @click="handleDelete">删除</span>
        <span class="btn1">上报</span>
        <span class="btn1">导出</span>
      </div>
    </div>

    <div class="query-content" id="el-scroll" ref="details">
      <com-term0 v-show="activeTab == 0" />
      <com-term1 v-show="activeTab == 1"  :data="data7"/>
    </div>
    <el-dialog
      title="新建"
      :visible.sync="addDialog"
      width="30%"
      :before-close="handleClose"
    >
      <div class="dialog-add-content">
        <el-form ref="add" :model="add">
          <el-form-item>
            <span>指标类别：</span>
            <el-select v-model="add.zblb" placeholder="请选择">
              <el-option
                v-for="item in statisticsInfo.obj.options"
                :key="item.value"
                :label="item.label"
                :value="item.label"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <span>指标名称：</span>
            <el-select v-model="add.zbmc" placeholder="请选择">
              <el-option
                v-for="item in statisticsInfo.obj.options"
                :key="item.value"
                :label="item.label"
                :value="item.label"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <span>单位：</span>
            <el-select v-model="add.uom" placeholder="请选择">
              <el-option
                v-for="item in statisticsInfo.obj.options"
                :key="item.value"
                :label="item.label"
                :value="item.label"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <span>申请标准：</span>
            <el-input v-model="add.sqbz" placeholder="请输入内容"></el-input>
          </el-form-item>
          <el-form-item>
            <span>申报数量：</span>
            <el-input v-model="add.sbsl" placeholder="请输入内容"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialog = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </section>
</template>
<script>
import mock from "@/utils/mock";
import comTabs from "@/components/comTabs";
import comTerm0 from "./details/comTerm0.vue";
import comTerm1 from "./details/comTerm1.vue";
export default {
  name: "comSelf",
  components: {
    comTabs,
    comTerm0,
    comTerm1,
  },
  props: {},
  computed: {},
  watch: {},
  data() {
    return {
      activeTab: 0,
      statisticsInfo: mock.statistics.statistics.viewInfo,
      statisticsInit: mock.statistics.statistics.init,
      loading: false,
      name: "",
      phone: "",
      dm: "",
      content: "查看指标解释查看指标解释",
      value: "",
      addDialog: false,
      add:{
        zblb:'',
        zbmc:'',
        uom:'',
        sqbz:'',
        sbsl:''
      },
      data7:null
    };
  },
  mounted() {
    this.tableMode()
    // let element = document.querySelector("#el-scroll");
    // element.addEventListener("scroll", this.handleScroll, true);
  },
  methods: {
    async tableMode() {
      let obj = await this.statisticsInit.tableMode();
      this.data7 = obj.slice(344, 352);
      // console.log(this.data7,'第一次');
    },
    handleDelete(){
      this.$confirm("您确定要删除吗？","信息",{
        comfirmButtonText:"确定",
        cancelButtonText:"取消",
        type:"warning"
      }).then(()=>{
        console.log("删除成功");
      }).catch(()=>{
        console.log("取消删除");
      })
    },
    handleSubmit(){
      this.addDialog = false
      console.log(this.add);
      
      this.data7.push(this.add)
      // console.log(this.data7,'将add对象push到data7数组');
      this.add = {}
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    changeTab(x, y) {
      this.activeTab = x;
    },

    handleOpen() {
      this.$alert(this.content, "查看指标解释", {
        confirmButtonText: "关闭",
        callback: (action) => {
          // this.$message({
          //   type: 'info',
          //   message: `action: ${ action }`
          // });
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.query {
  margin-top: 20px;
  &-header {
    display: flex;
    justify-content: space-between;
    > div {
      display: flex;
      justify-content: space-between;
      width: 342px;
      > span {
        cursor: pointer;
        padding: 6px 20px;
        border-radius: 5px;
      }
      .btn1 {
        background-color: #fff;
        border: 1px solid #d7d4d4;
        color: #333;
      }
      .btn2 {
        background-color: #2f82ff;
        border: 1px solid #2f82ff;
        color: #fff;
      }
    }
  }
  &-tabs {
    width: 700px !important;
    display: flex;
    flex-direction: column;
    margin-right: 18px;

    &-item {
      text-align: center;
      font-size: 14px;
      color: #333;
      line-height: 30px;
      cursor: pointer;
    }
    .activeTab {
      color: #2f82ff;
      font-weight: bold;
      border-bottom: 2px solid #2f82ff;
    }
  }
  &-content {
    margin-top: 22px;
  }
}
.query /deep/ .tabs {
  > div {
    flex: none;
    margin-right: 40px;
    margin-left: 20px;
  }
}
</style>
<style lang="scss" scoped>
.term0 {
  min-height: 720px;
  background-color: #fff;
  border-radius: 10px;
  padding: 20px;
  &-top {
    display: inline-block;
    display: flex;
    justify-content: space-between;
    padding-bottom: 25px;
    border-bottom: 1px solid #d7d7d7;
    &-info {
      display: inline-block;
      line-height: 40px;
      margin-right: 30px;
      .el-input {
        width: 62%;
      }
    }
    &-right {
      display: flex;
      > span {
        margin-left: 20px;
        padding: 0px 15px;
        border: 1px solid #d7d7d7;
        line-height: 34px;
        cursor: pointer;
        color: #fff;
        background-color: #2f82ff;
      }
    }
  }
  &-content {
    margin-top: 25px;
    .icon {
      cursor: pointer;
      position: absolute;
      right: 8px;
    }
    &-title {
      margin-bottom: 20px;
    }
  }
}
.term0-top-info /deep/ .el-input__inner {
  height: 34px;
}
.dialog-add-content /deep/ .el-form-item__content{
  > span{
    width: 80px;
    text-align: right;
    display: inline-block;
  }
}
.dialog-add-content /deep/ .el-select{
  width: 270px;
}
.dialog-add-content /deep/ .el-input{
  width: 270px;
}
</style>
